import React from 'react';

import { StandardSection } from '@commons/standard-section/StandardSection';

import { CategoryTile } from './category-tile/CategoryTile';

import cx from 'classnames';

import { categories } from './payload';

import * as styles from './category-browser.module.scss';

export const CategoryBrowser = ({
  classNames: {
    section,
    innerWrapper,
    outerWrapper,
    title: titleClassNameProp,
    subtitle: subtitleClassNameProp,
    titlesContainer,
  } = {},
  isBottom = false,
  currentPath,
}) => {
  const filteredCategories = categories.filter((category) => category.link !== currentPath);
  return (
    <StandardSection
      className={styles.container}
      classNames={{
        section: isBottom ? cx(section, styles.placedBottomSection) : section,
        innerWrapper: isBottom
          ? cx(styles.innerWrapper, styles.placedBottomInnerWrapper, innerWrapper)
          : cx(styles.innerWrapper, innerWrapper),
        outerWrapper: isBottom
          ? cx(styles.outerWrapper, styles.placedBottomOuterWrapper, outerWrapper)
          : cx(styles.outerWrapper, outerWrapper),
        title: titleClassNameProp,
        subtitle: subtitleClassNameProp,
        titlesContainer,
      }}
    >
      <h2 className={styles.categoriesHeader}>
        {filteredCategories.length > 3 ? 'Browse by category' : 'Check other categories'}
      </h2>
      <div className={styles.categories}>
        {filteredCategories.slice(0, 3).map((category) => (
          <CategoryTile category={category} key={category.title} />
        ))}
      </div>
    </StandardSection>
  );
};
